(function () {
  const originalTitle = document.title;
  const awayTitle = "Still Thinking About Steak? | Allen Brothers";
  let hasAnimated = false;

  document.addEventListener("visibilitychange", function () {
    if (document.hidden) {
      if (!hasAnimated) {
        document.title = awayTitle;
        hasAnimated = true;
      }
    } else {
      document.title = originalTitle;
      hasAnimated = false;
    }
  });
})();
